import { wmsConnector } from './wmsConnector'
import { wfsConnector } from './wfsConnector'
import { esriRestConnector } from './esriRestConnector'

// Un conector por protocolo de capa externa "de sesión" (no persistida). Agregar un tipo
// nuevo (OGC API Features, WMTS, etc.) es sumar un módulo acá con la misma interfaz:
// { id, serviceType, label, matchesUrl(url), detect(url), createOlLayer(layerConfig), queryFeatures(ctx) }.
export const CONNECTORS = [wmsConnector, wfsConnector, esriRestConnector]

export function getConnector(providerName) {
  return CONNECTORS.find(c => c.id === providerName) || null
}

/**
 * Conecta contra `baseUrl` y devuelve { connector, layers }.
 * - forcedType concreto (uno de los `id` de CONNECTORS): usa ese conector, su error se propaga tal cual.
 * - forcedType 'auto' (o vacío): prueba los conectores en orden (los que matchean la URL primero),
 *   y devuelve el primero que responda con capas. Si todos fallan, error combinado.
 */
export async function detectService(baseUrl, forcedType) {
  if (forcedType && forcedType !== 'auto') {
    const connector = getConnector(forcedType)
    if (!connector) throw new Error('Tipo de servicio desconocido.')
    const layers = await connector.detect(baseUrl)
    return { connector, layers }
  }

  const ordered = [...CONNECTORS].sort((a, b) => Number(b.matchesUrl(baseUrl)) - Number(a.matchesUrl(baseUrl)))
  for (const connector of ordered) {
    try {
      const layers = await connector.detect(baseUrl)
      return { connector, layers }
    } catch (e) {
      console.warn(`[externalLayers] ${connector.label} no respondió:`, e.message)
    }
  }
  throw new Error('No se pudo conectar como WMS, WFS ni Esri REST — revisa la URL o los permisos CORS.')
}
